import { render, staticRenderFns } from "./group-summary.vue?vue&type=template&id=026d145f&"
import script from "./group-summary.vue?vue&type=script&lang=js&"
export * from "./group-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports